import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import BookingDetails from './BookingDetails';

interface IBookingDialogProps {
  isOpen: boolean;
  onClose: () => void;
  order: any;
  availableTimeslots: any[];
  myMeetings: any[];
  myOrder: any;
  activeTab: string;
  style: any;
  settings: any;
}

export default function PersonDialog({ isOpen, onClose, order, availableTimeslots, myMeetings, myOrder, activeTab, settings, style }: IBookingDialogProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto" style={{ fontFamily: style?.['font-family'] }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white  text-left align-middle shadow-xl transition-all">
                <BookingDetails
                  activeTab={activeTab}
                  settings={settings}
                  myMeetings={myMeetings}
                  availableTimeSlots={availableTimeslots}
                  myOrder={myOrder}
                  goBack={onClose}
                  order={order}
                />
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
